module.exports = __webpack_public_path__ + "img/img-swine.b199f810.svg";